var render = function () {
  var this$1 = this
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "menuAdjustDrawer" },
    [
      _c(
        "el-form",
        {
          ref: "form",
          attrs: {
            model: _vm.form,
            "label-position": "left",
            inline: true,
            size: "mini",
          },
        },
        [
          _c(
            "el-form-item",
            { attrs: { label: "公司名称:", prop: "company_name" } },
            [
              _c("el-input", {
                staticStyle: { width: "157px" },
                attrs: { placeholder: "请输入" },
                model: {
                  value: _vm.form.company_name,
                  callback: function ($$v) {
                    _vm.$set(_vm.form, "company_name", $$v)
                  },
                  expression: "form.company_name",
                },
              }),
            ],
            1
          ),
          _c(
            "el-form-item",
            { attrs: { label: "调价基数", prop: "money_type" } },
            [
              _c(
                "el-select",
                {
                  staticClass: "input__style",
                  model: {
                    value: _vm.form.money_type,
                    callback: function ($$v) {
                      _vm.$set(_vm.form, "money_type", $$v)
                    },
                    expression: "form.money_type",
                  },
                },
                _vm._l(_vm.moneyTypes, function (item) {
                  return _c("el-option", {
                    attrs: { label: item.name, value: item.id },
                  })
                }),
                1
              ),
            ],
            1
          ),
          _c(
            "el-form-item",
            { attrs: { label: "折扣" } },
            [
              _c(
                "el-form-item",
                {
                  attrs: {
                    prop: "by_ratio_adjust_gt",
                    rules: [
                      {
                        required: false,
                        trigger: "change",
                        message: "请输入折扣",
                      },
                      {
                        pattern: /^(\d{1,3}|1000)$/,
                        message: "请填写0-1000整数",
                      },
                    ],
                  },
                },
                [
                  _c(
                    "el-input",
                    {
                      staticClass: "input__style",
                      attrs: { placeholder: "最小值", clearable: "" },
                      model: {
                        value: _vm.form.by_ratio_adjust_gt,
                        callback: function ($$v) {
                          _vm.$set(
                            _vm.form,
                            "by_ratio_adjust_gt",
                            typeof $$v === "string" ? $$v.trim() : $$v
                          )
                        },
                        expression: "form.by_ratio_adjust_gt",
                      },
                    },
                    [_c("template", { slot: "append" }, [_vm._v("%")])],
                    2
                  ),
                ],
                1
              ),
              _c("span", { staticClass: "split" }, [_vm._v("—")]),
              _c(
                "el-form-item",
                {
                  attrs: {
                    prop: "by_ratio_adjust_lt",
                    rules: [
                      {
                        required: false,
                        trigger: "change",
                        message: "请输入折扣",
                      },
                      {
                        pattern: /^(\d{1,3}|1000)$/,
                        message: "请填写0-1000整数",
                      },
                    ],
                  },
                },
                [
                  _c(
                    "el-input",
                    {
                      staticClass: "input__style",
                      attrs: { placeholder: "最大值", clearable: "" },
                      model: {
                        value: _vm.form.by_ratio_adjust_lt,
                        callback: function ($$v) {
                          _vm.$set(
                            _vm.form,
                            "by_ratio_adjust_lt",
                            typeof $$v === "string" ? $$v.trim() : $$v
                          )
                        },
                        expression: "form.by_ratio_adjust_lt",
                      },
                    },
                    [_c("template", { slot: "append" }, [_vm._v("%")])],
                    2
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "el-form-item",
            { attrs: { label: "京东评论数" } },
            [
              _c(
                "el-form-item",
                { attrs: { prop: "number_comments_gt" } },
                [
                  _c(
                    "el-input",
                    {
                      staticClass: "input__style",
                      attrs: { placeholder: "最小值", clearable: "" },
                      model: {
                        value: _vm.form.number_comments_gt,
                        callback: function ($$v) {
                          _vm.$set(
                            _vm.form,
                            "number_comments_gt",
                            typeof $$v === "string" ? $$v.trim() : $$v
                          )
                        },
                        expression: "form.number_comments_gt",
                      },
                    },
                    [_c("template", { slot: "append" }, [_vm._v("万")])],
                    2
                  ),
                ],
                1
              ),
              _c("span", { staticClass: "split" }, [_vm._v("—")]),
              _c(
                "el-form-item",
                { attrs: { prop: "number_comments_lt" } },
                [
                  _c(
                    "el-input",
                    {
                      staticClass: "input__style",
                      attrs: { placeholder: "最大值", clearable: "" },
                      model: {
                        value: _vm.form.number_comments_lt,
                        callback: function ($$v) {
                          _vm.$set(
                            _vm.form,
                            "number_comments_lt",
                            typeof $$v === "string" ? $$v.trim() : $$v
                          )
                        },
                        expression: "form.number_comments_lt",
                      },
                    },
                    [_c("template", { slot: "append" }, [_vm._v("万")])],
                    2
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "el-form-item",
            { attrs: { label: "利润率" } },
            [
              _c(
                "el-form-item",
                { attrs: { prop: "entity_profit_rate_gt" } },
                [
                  _c(
                    "el-input",
                    {
                      staticClass: "input__style",
                      attrs: { placeholder: "最小值", clearable: "" },
                      model: {
                        value: _vm.form.entity_profit_rate_gt,
                        callback: function ($$v) {
                          _vm.$set(
                            _vm.form,
                            "entity_profit_rate_gt",
                            typeof $$v === "string" ? $$v.trim() : $$v
                          )
                        },
                        expression: "form.entity_profit_rate_gt",
                      },
                    },
                    [_c("template", { slot: "append" }, [_vm._v("%")])],
                    2
                  ),
                ],
                1
              ),
              _c("span", { staticClass: "split" }, [_vm._v("—")]),
              _c(
                "el-form-item",
                { attrs: { prop: "entity_profit_rate_lt" } },
                [
                  _c(
                    "el-input",
                    {
                      staticClass: "input__style",
                      attrs: { placeholder: "最大值", clearable: "" },
                      model: {
                        value: _vm.form.entity_profit_rate_lt,
                        callback: function ($$v) {
                          _vm.$set(
                            _vm.form,
                            "entity_profit_rate_lt",
                            typeof $$v === "string" ? $$v.trim() : $$v
                          )
                        },
                        expression: "form.entity_profit_rate_lt",
                      },
                    },
                    [_c("template", { slot: "append" }, [_vm._v("%")])],
                    2
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "el-form-item",
            { attrs: { label: "是否显示划线价", prop: "is_show_line_price" } },
            [
              _c(
                "el-select",
                {
                  staticClass: "input__style",
                  attrs: { clearable: "", filterable: "" },
                  model: {
                    value: _vm.form.is_show_line_price,
                    callback: function ($$v) {
                      _vm.$set(_vm.form, "is_show_line_price", $$v)
                    },
                    expression: "form.is_show_line_price",
                  },
                },
                [
                  _c("el-option", { attrs: { label: "否", value: "0" } }),
                  _c("el-option", { attrs: { label: "是", value: "1" } }),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "el-form-item",
            { attrs: { label: "特价商品", prop: "is_show_special" } },
            [
              _c(
                "el-select",
                {
                  staticClass: "input__style",
                  attrs: { clearable: "", filterable: "" },
                  model: {
                    value: _vm.form.is_show_special,
                    callback: function ($$v) {
                      _vm.$set(_vm.form, "is_show_special", $$v)
                    },
                    expression: "form.is_show_special",
                  },
                },
                [
                  _c("el-option", { attrs: { label: "全部", value: "" } }),
                  _c("el-option", { attrs: { label: "不展示", value: "0" } }),
                  _c("el-option", { attrs: { label: "展示", value: "1" } }),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "el-form-item",
            [
              _c(
                "el-button",
                {
                  attrs: { type: "primary", size: "mini" },
                  on: { click: _vm.search },
                },
                [_vm._v("搜索")]
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "div",
        { staticStyle: { "margin-bottom": "15px" } },
        [
          _c(
            "el-button",
            {
              staticClass: "el-icon-plus",
              attrs: { size: "mini", type: "success" },
              on: {
                click: function ($event) {
                  return _vm.createAdjust("add", {})
                },
              },
            },
            [_vm._v("添加")]
          ),
          _c(
            "el-button",
            {
              attrs: { size: "mini", type: "primary" },
              on: { click: _vm.goLog },
            },
            [_vm._v("日志")]
          ),
        ],
        1
      ),
      _c(
        "el-table",
        {
          staticStyle: { width: "100%" },
          attrs: {
            border: "",
            "header-cell-style": { background: "#F1F1F1", color: "#333333" },
            data: _vm.dataList,
            "tooltip-effect": "dark",
          },
        },
        [
          _c("el-table-column", {
            attrs: {
              prop: "category_name",
              label: "客户名称-ID（添加/更新时间）",
              width: "240px",
              "show-overflow-tooltip": "",
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _c("div", [_vm._v(_vm._s(scope.row.company_name))]),
                    _c("div", [_vm._v(_vm._s(scope.row.company_id))]),
                    _c("div"),
                    _c("div", [
                      _vm._v(
                        _vm._s(scope.row.created_time) +
                          " " +
                          _vm._s(scope.row.creator_name)
                      ),
                    ]),
                    _c("div", [
                      _vm._v(
                        _vm._s(scope.row.updated_time) +
                          " " +
                          _vm._s(scope.row.updater_name)
                      ),
                    ]),
                  ]
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: { prop: "category_name", label: "商品折扣", width: "240px" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _c("div", [
                      _vm._v(
                        "商品折扣：" +
                          _vm._s(scope.row.is_open_discount_message)
                      ),
                    ]),
                    scope.row.is_open_discount === "1"
                      ? [
                          _c("div", [
                            _vm._v(
                              " 调价折扣：" +
                                _vm._s(scope.row.money_type_name) +
                                " " +
                                _vm._s(scope.row.by_ratio_adjust) +
                                "% "
                            ),
                          ]),
                          _c("div", [
                            _vm._v(
                              "划线价：" +
                                _vm._s(scope.row.is_show_line_price_message)
                            ),
                          ]),
                        ]
                      : _vm._e(),
                    _c("div", [
                      _vm._v(
                        " 评论数：" +
                          _vm._s(
                            scope.row.is_number_comments === "1"
                              ? ""
                              : scope.row.is_number_comments_message
                          ) +
                          " "
                      ),
                      scope.row.is_number_comments === "1"
                        ? _c("span", [
                            _vm._v(
                              " " +
                                _vm._s(scope.row.number_comments) +
                                "万以上 "
                            ),
                          ])
                        : _vm._e(),
                    ]),
                    _c("div", [
                      _vm._v(
                        " 利润率：" +
                          _vm._s(
                            scope.row.is_entity_profit_rate === "1"
                              ? ""
                              : scope.row.is_entity_profit_rate_message
                          ) +
                          " "
                      ),
                      scope.row.is_entity_profit_rate === "1"
                        ? _c("span", [
                            _vm._v(
                              " " + _vm._s(scope.row.entity_profit_rate) + "% "
                            ),
                          ])
                        : _vm._e(),
                    ]),
                    _c("div", [
                      _vm._v(
                        "特价商品：" + _vm._s(scope.row.is_show_special_message)
                      ),
                    ]),
                    ["entity", "new_entity"].includes(_vm.trendParams.type)
                      ? _c("div", [
                          _vm._v(
                            " 最小起购金额：" +
                              _vm._s(
                                scope.row.is_minimum_amount === "1"
                                  ? ""
                                  : scope.row.is_minimum_amount_message
                              ) +
                              " "
                          ),
                          scope.row.is_minimum_amount === "1"
                            ? _c("span", [
                                _vm._v(_vm._s(scope.row.minimum_amount)),
                              ])
                            : _vm._e(),
                        ])
                      : _vm._e(),
                  ]
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: {
              prop: "entity_profit_rate",
              label: "商品关键词黑名单",
              "show-overflow-tooltip": "",
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _c("div", [
                      _vm._v(
                        " 商品关键词黑名单：" +
                          _vm._s(
                            scope.row.is_keyword_blacklist === "1"
                              ? ""
                              : scope.row.is_keyword_blacklist_message
                          ) +
                          " "
                      ),
                      scope.row.is_keyword_blacklist === "1"
                        ? _c("span", [
                            _vm._v(
                              " " + _vm._s(scope.row.keyword_blacklist) + " "
                            ),
                          ])
                        : _vm._e(),
                    ]),
                  ]
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: { label: "操作", width: "100px" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _c(
                      "el-button",
                      {
                        attrs: { type: "text" },
                        on: {
                          click: function ($event) {
                            return _vm.createAdjust("edit", scope.row)
                          },
                        },
                      },
                      [_vm._v("编辑")]
                    ),
                    _c(
                      "el-button",
                      {
                        staticStyle: { color: "red" },
                        attrs: { type: "text" },
                        on: {
                          click: function ($event) {
                            return _vm.delAdjust(scope.row)
                          },
                        },
                      },
                      [_vm._v("删除")]
                    ),
                  ]
                },
              },
            ]),
          }),
        ],
        1
      ),
      _c(
        "div",
        {
          staticStyle: {
            display: "flex",
            "justify-content": "end",
            "margin-top": "30px",
          },
        },
        [
          _c("el-pagination", {
            attrs: {
              background: "",
              layout: "total, sizes, prev, pager, next, jumper",
              "page-sizes": [20, 50, 100, 200],
              "page-size": 20,
              total: _vm.pages.totalCount,
              "current-page": _vm.pages.currentPage,
            },
            on: {
              "current-change": _vm.channelDataPage,
              "size-change": _vm.sizeChange,
            },
          }),
        ],
        1
      ),
      _c(
        "el-drawer",
        {
          attrs: {
            title: _vm.adjustTitle,
            visible: _vm.dialogVisible,
            size: "78%",
            "destroy-on-close": "",
            "append-to-body": true,
            "before-close": _vm.handleClose,
          },
          on: {
            "update:visible": function ($event) {
              _vm.dialogVisible = $event
            },
          },
        },
        [
          _c("div", { staticClass: "myDrawer" }, [
            _c(
              "div",
              { staticClass: "myDrawerMain" },
              [
                _c(
                  "el-form",
                  {
                    ref: "setFormRule",
                    staticClass: "setFormRule",
                    attrs: {
                      model: _vm.setFormRule,
                      "label-position": "right",
                      inline: "",
                      size: "small",
                      "label-width": "150px",
                      "label-suffix": ":",
                    },
                  },
                  [
                    _c(
                      "div",
                      [
                        _c(
                          "el-form-item",
                          {
                            attrs: {
                              label: "选择客户",
                              prop: "company_id",
                              rules: {
                                required: true,
                                message: "客户名称不能为空",
                                trigger: "change",
                              },
                            },
                          },
                          [
                            _vm.adjustType === "add"
                              ? _c(
                                  "el-select",
                                  {
                                    staticStyle: { width: "400px" },
                                    attrs: {
                                      filterable: "",
                                      remote: "",
                                      clearable: "",
                                      "remote-method": _vm.remoteMethodCompany,
                                      disabled: _vm.adjustType === "edit",
                                    },
                                    model: {
                                      value: _vm.setFormRule.company_id,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.setFormRule,
                                          "company_id",
                                          $$v
                                        )
                                      },
                                      expression: "setFormRule.company_id",
                                    },
                                  },
                                  _vm._l(_vm.sellUserList, function (item) {
                                    return _c("el-option", {
                                      attrs: {
                                        label: item.company_name,
                                        value: item.id,
                                      },
                                    })
                                  }),
                                  1
                                )
                              : _vm._e(),
                            _vm.adjustType === "edit"
                              ? _c("el-input", {
                                  staticStyle: { width: "400px" },
                                  attrs: {
                                    disabled: "",
                                    placeholder: "请输入",
                                  },
                                  model: {
                                    value: _vm.setFormRule.company_name,
                                    callback: function ($$v) {
                                      _vm.$set(
                                        _vm.setFormRule,
                                        "company_name",
                                        $$v
                                      )
                                    },
                                    expression: "setFormRule.company_name",
                                  },
                                })
                              : _vm._e(),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _c(
                      "div",
                      [
                        _c(
                          "el-form-item",
                          {
                            attrs: {
                              label: "商品折扣",
                              prop: "is_open_discount",
                              rules: [
                                {
                                  required: true,
                                  trigger: "change",
                                  message: "请选择",
                                },
                              ],
                            },
                          },
                          [
                            _c(
                              "el-radio-group",
                              {
                                model: {
                                  value: _vm.setFormRule.is_open_discount,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.setFormRule,
                                      "is_open_discount",
                                      $$v
                                    )
                                  },
                                  expression: "setFormRule.is_open_discount",
                                },
                              },
                              [
                                _c("el-radio", { attrs: { label: "1" } }, [
                                  _vm._v("开启"),
                                ]),
                                _c("el-radio", { attrs: { label: "0" } }, [
                                  _vm._v("关闭"),
                                ]),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                        ["1"].includes(_vm.setFormRule.is_open_discount)
                          ? [
                              _c(
                                "el-form-item",
                                {
                                  attrs: {
                                    label: "调价基数",
                                    prop: "money_type",
                                    rules: [
                                      {
                                        required: true,
                                        trigger: "change",
                                        message: "请选择调价基数",
                                      },
                                    ],
                                  },
                                },
                                [
                                  _c(
                                    "el-radio-group",
                                    {
                                      model: {
                                        value: _vm.setFormRule.money_type,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            _vm.setFormRule,
                                            "money_type",
                                            $$v
                                          )
                                        },
                                        expression: "setFormRule.money_type",
                                      },
                                    },
                                    _vm._l(_vm.moneyTypes, function (item) {
                                      return _c(
                                        "el-radio",
                                        {
                                          key: item.id,
                                          attrs: { label: item.id },
                                        },
                                        [_vm._v(_vm._s(item.name))]
                                      )
                                    }),
                                    1
                                  ),
                                ],
                                1
                              ),
                              _c(
                                "el-form-item",
                                {
                                  attrs: {
                                    label: "折扣",
                                    prop: "by_ratio_adjust",
                                    rules: [
                                      {
                                        required: true,
                                        trigger: "change",
                                        message: "请输入折扣",
                                      },
                                      {
                                        pattern: /^(\d{1,3}|1000)$/,
                                        message: "请填写0-1000整数",
                                      },
                                      {
                                        validator: function (
                                          rule,
                                          value,
                                          callback
                                        ) {
                                          if (!value) {
                                            return callback()
                                          }
                                          // 直接比较折扣值与预警值
                                          var discount = parseFloat(value)
                                          var minDiscount =
                                            this$1.warning_restrictions
                                          if (discount < minDiscount) {
                                            return callback(
                                              "折扣不可低于" +
                                                minDiscount +
                                                "，请重新输入！"
                                            )
                                          }
                                          callback()
                                        },
                                        trigger: ["input", "change", "blur"],
                                      },
                                    ],
                                  },
                                },
                                [
                                  _c(
                                    "span",
                                    { attrs: { slot: "label" }, slot: "label" },
                                    [
                                      _c(
                                        "span",
                                        {
                                          style: {
                                            color:
                                              _vm.setFormRule.by_ratio_adjust &&
                                              Number(
                                                _vm.setFormRule.by_ratio_adjust
                                              ) < this.warning_restrictions
                                                ? "red"
                                                : "",
                                          },
                                        },
                                        [_vm._v("折扣")]
                                      ),
                                      _c(
                                        "el-tooltip",
                                        {
                                          attrs: {
                                            content:
                                              "说明：基于调价基数设置折扣（设置范围：0-1000），商城中实际售价显示折扣后价格，用户按折扣后价格下单支付。",
                                            placement: "top",
                                          },
                                        },
                                        [
                                          _c("i", {
                                            staticClass:
                                              "el-icon-warning-outline",
                                          }),
                                        ]
                                      ),
                                    ],
                                    1
                                  ),
                                  _c(
                                    "el-input",
                                    {
                                      staticStyle: { width: "180px" },
                                      model: {
                                        value: _vm.setFormRule.by_ratio_adjust,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            _vm.setFormRule,
                                            "by_ratio_adjust",
                                            typeof $$v === "string"
                                              ? $$v.trim()
                                              : $$v
                                          )
                                        },
                                        expression:
                                          "setFormRule.by_ratio_adjust",
                                      },
                                    },
                                    [
                                      _c("template", { slot: "append" }, [
                                        _vm._v("%"),
                                      ]),
                                    ],
                                    2
                                  ),
                                ],
                                1
                              ),
                            ]
                          : _vm._e(),
                      ],
                      2
                    ),
                    _c(
                      "div",
                      [
                        _c(
                          "el-form-item",
                          {
                            attrs: {
                              label: "划线价",
                              prop: "is_show_line_price",
                              rules: [
                                {
                                  required: true,
                                  trigger: "change",
                                  message: "请选择划线价",
                                },
                              ],
                            },
                          },
                          [
                            _c(
                              "span",
                              { attrs: { slot: "label" }, slot: "label" },
                              [
                                _c("span", [_vm._v("划线价")]),
                                _c(
                                  "el-tooltip",
                                  {
                                    attrs: {
                                      content:
                                        "说明：控制在商城商品信息中是否显示划线价；此处的划线价显示/隐藏设置，优先级最高。（高于【菜单管理】中划线价显示/隐藏设置）。",
                                      placement: "top",
                                    },
                                  },
                                  [
                                    _c("i", {
                                      staticClass: "el-icon-warning-outline",
                                    }),
                                  ]
                                ),
                              ],
                              1
                            ),
                            _c(
                              "el-radio-group",
                              {
                                model: {
                                  value: _vm.setFormRule.is_show_line_price,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.setFormRule,
                                      "is_show_line_price",
                                      $$v
                                    )
                                  },
                                  expression: "setFormRule.is_show_line_price",
                                },
                              },
                              [
                                _c("el-radio", { attrs: { label: "1" } }, [
                                  _vm._v("显示"),
                                ]),
                                _c("el-radio", { attrs: { label: "0" } }, [
                                  _vm._v("隐藏"),
                                ]),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                        _vm.setFormRule.is_show_line_price === "1"
                          ? _c(
                              "el-form-item",
                              {
                                attrs: {
                                  label: "划线价基数",
                                  prop: "line_price_type",
                                  rules: [
                                    {
                                      required: true,
                                      trigger: "change",
                                      message: "请选择划线价基数",
                                    },
                                  ],
                                },
                              },
                              [
                                _c(
                                  "span",
                                  { attrs: { slot: "label" }, slot: "label" },
                                  [
                                    _c("span", [_vm._v("划线价基数")]),
                                    _c(
                                      "el-tooltip",
                                      {
                                        attrs: {
                                          content: "说明：将选中价格做为划线价",
                                          placement: "top",
                                        },
                                      },
                                      [
                                        _c("i", {
                                          staticClass:
                                            "el-icon-warning-outline",
                                        }),
                                      ]
                                    ),
                                  ],
                                  1
                                ),
                                _c(
                                  "el-radio-group",
                                  {
                                    model: {
                                      value: _vm.setFormRule.line_price_type,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.setFormRule,
                                          "line_price_type",
                                          $$v
                                        )
                                      },
                                      expression: "setFormRule.line_price_type",
                                    },
                                  },
                                  [
                                    _c("el-radio", { attrs: { label: "1" } }, [
                                      _vm._v("市场价"),
                                    ]),
                                    _c("el-radio", { attrs: { label: "2" } }, [
                                      _vm._v("建议售价"),
                                    ]),
                                  ],
                                  1
                                ),
                              ],
                              1
                            )
                          : _vm._e(),
                      ],
                      1
                    ),
                    _c(
                      "div",
                      [
                        _c(
                          "el-form-item",
                          {
                            attrs: {
                              label: "评论数限制",
                              prop: "is_number_comments",
                              rules: [
                                {
                                  required: true,
                                  trigger: "change",
                                  message: "请选择",
                                },
                              ],
                            },
                          },
                          [
                            _c(
                              "el-radio-group",
                              {
                                model: {
                                  value: _vm.setFormRule.is_number_comments,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.setFormRule,
                                      "is_number_comments",
                                      $$v
                                    )
                                  },
                                  expression: "setFormRule.is_number_comments",
                                },
                              },
                              [
                                _c("el-radio", { attrs: { label: "1" } }, [
                                  _vm._v("限制"),
                                ]),
                                _c("el-radio", { attrs: { label: "0" } }, [
                                  _vm._v("不限制"),
                                ]),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                        _vm.setFormRule.is_number_comments === "1"
                          ? _c(
                              "el-form-item",
                              {
                                attrs: {
                                  prop: "number_comments",
                                  rules: [
                                    {
                                      required: true,
                                      trigger: "change",
                                      message: "请输入",
                                    },
                                    {
                                      pattern:
                                        /^(?:[0-9]{1,4}|0)(?:\.\d{1,4})?$/,
                                      message: "数字0-9999，小数点支持4位",
                                    },
                                  ],
                                },
                              },
                              [
                                _c(
                                  "span",
                                  { attrs: { slot: "label" }, slot: "label" },
                                  [
                                    _c("span", [_vm._v("京东评论数")]),
                                    _c(
                                      "el-tooltip",
                                      {
                                        attrs: {
                                          content:
                                            "说明：（设置范围：0-9999，小数点4位），在商城中只展示高于（含）此评论数的商品",
                                          placement: "top",
                                        },
                                      },
                                      [
                                        _c("i", {
                                          staticClass:
                                            "el-icon-warning-outline",
                                        }),
                                      ]
                                    ),
                                  ],
                                  1
                                ),
                                _c(
                                  "el-input",
                                  {
                                    staticStyle: { width: "150px" },
                                    model: {
                                      value: _vm.setFormRule.number_comments,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.setFormRule,
                                          "number_comments",
                                          typeof $$v === "string"
                                            ? $$v.trim()
                                            : $$v
                                        )
                                      },
                                      expression: "setFormRule.number_comments",
                                    },
                                  },
                                  [
                                    _c("template", { slot: "append" }, [
                                      _vm._v("万以上"),
                                    ]),
                                  ],
                                  2
                                ),
                              ],
                              1
                            )
                          : _vm._e(),
                      ],
                      1
                    ),
                    _c(
                      "div",
                      [
                        _c(
                          "el-form-item",
                          {
                            attrs: {
                              label: "利润率控制",
                              prop: "is_entity_profit_rate",
                              rules: [
                                {
                                  required: true,
                                  trigger: "change",
                                  message: "请选择",
                                },
                              ],
                            },
                          },
                          [
                            _c(
                              "el-radio-group",
                              {
                                model: {
                                  value: _vm.setFormRule.is_entity_profit_rate,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.setFormRule,
                                      "is_entity_profit_rate",
                                      $$v
                                    )
                                  },
                                  expression:
                                    "setFormRule.is_entity_profit_rate",
                                },
                              },
                              [
                                _c("el-radio", { attrs: { label: "1" } }, [
                                  _vm._v("控制"),
                                ]),
                                _c("el-radio", { attrs: { label: "0" } }, [
                                  _vm._v("不控制"),
                                ]),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                        _vm.setFormRule.is_entity_profit_rate === "1"
                          ? _c(
                              "el-form-item",
                              {
                                attrs: {
                                  prop: "entity_profit_rate",
                                  label: "利润率%",
                                  rules: [
                                    {
                                      required: true,
                                      trigger: "change",
                                      message: "请输入",
                                    },
                                    {
                                      pattern:
                                        /^-?([0-9]{1,4}|9999)(\.[0-9]{1,2})?$/,
                                      message: "数字-9999～9999、小数点2位",
                                    },
                                  ],
                                },
                              },
                              [
                                _c(
                                  "span",
                                  { attrs: { slot: "label" }, slot: "label" },
                                  [
                                    _c("span", [_vm._v("利润率%")]),
                                    _c(
                                      "el-tooltip",
                                      {
                                        attrs: {
                                          content:
                                            "说明：（设置范围：-9999～9999、小数点2位 ），在商城中只展示高于（含）此利润率的商品",
                                          placement: "top",
                                        },
                                      },
                                      [
                                        _c("i", {
                                          staticClass:
                                            "el-icon-warning-outline",
                                        }),
                                      ]
                                    ),
                                  ],
                                  1
                                ),
                                _c(
                                  "el-input",
                                  {
                                    staticStyle: { width: "150px" },
                                    model: {
                                      value: _vm.setFormRule.entity_profit_rate,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.setFormRule,
                                          "entity_profit_rate",
                                          typeof $$v === "string"
                                            ? $$v.trim()
                                            : $$v
                                        )
                                      },
                                      expression:
                                        "setFormRule.entity_profit_rate",
                                    },
                                  },
                                  [
                                    _c("template", { slot: "append" }, [
                                      _vm._v("%"),
                                    ]),
                                  ],
                                  2
                                ),
                              ],
                              1
                            )
                          : _vm._e(),
                      ],
                      1
                    ),
                    _c(
                      "div",
                      [
                        _c(
                          "el-form-item",
                          {
                            attrs: {
                              label: "商品关键词黑名单",
                              prop: "is_keyword_blacklist",
                              rules: [
                                {
                                  required: true,
                                  trigger: "change",
                                  message: "请选择",
                                },
                              ],
                            },
                          },
                          [
                            _c(
                              "el-radio-group",
                              {
                                model: {
                                  value: _vm.setFormRule.is_keyword_blacklist,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.setFormRule,
                                      "is_keyword_blacklist",
                                      $$v
                                    )
                                  },
                                  expression:
                                    "setFormRule.is_keyword_blacklist",
                                },
                              },
                              [
                                _c("el-radio", { attrs: { label: "1" } }, [
                                  _vm._v("设置"),
                                ]),
                                _c("el-radio", { attrs: { label: "0" } }, [
                                  _vm._v("不设置"),
                                ]),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                        _vm.setFormRule.is_keyword_blacklist === "1"
                          ? _c(
                              "el-form-item",
                              {
                                attrs: {
                                  label: "关键词黑名单",
                                  prop: "keyword_blacklist",
                                },
                              },
                              [
                                _c(
                                  "span",
                                  { attrs: { slot: "label" }, slot: "label" },
                                  [
                                    _c("span", [_vm._v("关键词黑名单")]),
                                    _c(
                                      "el-tooltip",
                                      {
                                        attrs: {
                                          content:
                                            "说明：设置黑名单关键词后，如果商品名称中包含其中任意关键词，则在商城菜单中不显示该商品。",
                                          placement: "top",
                                        },
                                      },
                                      [
                                        _c("i", {
                                          staticClass:
                                            "el-icon-warning-outline",
                                        }),
                                      ]
                                    ),
                                  ],
                                  1
                                ),
                                _c(
                                  "div",
                                  {
                                    staticStyle: {
                                      display: "flex",
                                      "align-items": "baseline",
                                    },
                                  },
                                  [
                                    _c("el-input", {
                                      staticStyle: {
                                        width: "200px",
                                        margin: "0 10px 10px 0",
                                      },
                                      attrs: {
                                        type: "text",
                                        maxlength: "30",
                                        placeholder: "请输入黑名单关键词",
                                      },
                                      model: {
                                        value: _vm.keyword,
                                        callback: function ($$v) {
                                          _vm.keyword =
                                            typeof $$v === "string"
                                              ? $$v.trim()
                                              : $$v
                                        },
                                        expression: "keyword",
                                      },
                                    }),
                                    _c(
                                      "el-button",
                                      {
                                        attrs: {
                                          type: "success",
                                          size: "small",
                                        },
                                        on: { click: _vm.saveKey },
                                      },
                                      [_vm._v("添加")]
                                    ),
                                  ],
                                  1
                                ),
                                _vm._l(
                                  _vm.setFormRule.keyword_blacklist,
                                  function (item, index) {
                                    return _c(
                                      "el-tag",
                                      {
                                        key: index,
                                        staticStyle: { "margin-right": "6px" },
                                        attrs: { closable: "", type: "danger" },
                                        on: {
                                          close: function ($event) {
                                            return _vm.deleteKey(index)
                                          },
                                        },
                                      },
                                      [_vm._v(" " + _vm._s(item) + " ")]
                                    )
                                  }
                                ),
                              ],
                              2
                            )
                          : _vm._e(),
                      ],
                      1
                    ),
                    ["entity", "code", "vipcard", "new_entity"].includes(
                      _vm.trendParams.type
                    )
                      ? _c(
                          "div",
                          [
                            _c(
                              "el-form-item",
                              {
                                attrs: {
                                  label: "特价商品展示规则",
                                  prop: "is_show_special",
                                  rules: [
                                    {
                                      required: true,
                                      trigger: "change",
                                      message: "请选择",
                                    },
                                  ],
                                },
                              },
                              [
                                _c(
                                  "span",
                                  { attrs: { slot: "label" }, slot: "label" },
                                  [
                                    _vm._v(" 特价商品展示规则 "),
                                    _c(
                                      "el-tooltip",
                                      {
                                        staticClass: "item",
                                        attrs: {
                                          effect: "light",
                                          placement: "top",
                                        },
                                      },
                                      [
                                        _c("i", {
                                          staticClass:
                                            "el-icon-warning-outline",
                                          staticStyle: {
                                            color: "#909399",
                                            "margin-left": "5px",
                                          },
                                        }),
                                        _c(
                                          "div",
                                          {
                                            attrs: { slot: "content" },
                                            slot: "content",
                                          },
                                          [
                                            _c("div", [
                                              _vm._v(
                                                "不展示：特价商品不展示在商品列表"
                                              ),
                                            ]),
                                            _c("div", [
                                              _vm._v(
                                                "展示：特价商品需要忽略利润率控制"
                                              ),
                                            ]),
                                          ]
                                        ),
                                      ]
                                    ),
                                  ],
                                  1
                                ),
                                _c(
                                  "el-radio-group",
                                  {
                                    model: {
                                      value: _vm.setFormRule.is_show_special,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.setFormRule,
                                          "is_show_special",
                                          $$v
                                        )
                                      },
                                      expression: "setFormRule.is_show_special",
                                    },
                                  },
                                  [
                                    _c("el-radio", { attrs: { label: "1" } }, [
                                      _vm._v("展示"),
                                    ]),
                                    _c("el-radio", { attrs: { label: "0" } }, [
                                      _vm._v("不展示"),
                                    ]),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                            _vm.setFormRule.is_show_special === "1"
                              ? _c(
                                  "el-form-item",
                                  {
                                    attrs: {
                                      label: "特价商品价格处理",
                                      prop: "is_use_special",
                                      rules: [
                                        {
                                          required: true,
                                          trigger: "change",
                                          message: "请选择",
                                        },
                                      ],
                                    },
                                  },
                                  [
                                    _c(
                                      "span",
                                      {
                                        attrs: { slot: "label" },
                                        slot: "label",
                                      },
                                      [
                                        _vm._v(" 特价商品价格处理 "),
                                        _c(
                                          "el-tooltip",
                                          {
                                            staticClass: "item",
                                            attrs: {
                                              effect: "light",
                                              placement: "top",
                                            },
                                          },
                                          [
                                            _c("i", {
                                              staticClass:
                                                "el-icon-warning-outline",
                                              staticStyle: {
                                                color: "#909399",
                                                "margin-left": "5px",
                                              },
                                            }),
                                            _c(
                                              "div",
                                              {
                                                attrs: { slot: "content" },
                                                slot: "content",
                                              },
                                              [
                                                _c("div", [
                                                  _vm._v(
                                                    "仅使用商品特价的价格不会根据折扣配置再次打折"
                                                  ),
                                                ]),
                                              ]
                                            ),
                                          ]
                                        ),
                                      ],
                                      1
                                    ),
                                    _c(
                                      "el-radio-group",
                                      {
                                        model: {
                                          value: _vm.setFormRule.is_use_special,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              _vm.setFormRule,
                                              "is_use_special",
                                              $$v
                                            )
                                          },
                                          expression:
                                            "setFormRule.is_use_special",
                                        },
                                      },
                                      [
                                        _c(
                                          "el-radio",
                                          { attrs: { label: "1" } },
                                          [_vm._v("使用特价价格")]
                                        ),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                )
                              : _vm._e(),
                          ],
                          1
                        )
                      : _vm._e(),
                    ["entity", "new_entity"].includes(_vm.trendParams.type)
                      ? _c(
                          "div",
                          [
                            _c(
                              "el-form-item",
                              {
                                attrs: {
                                  label: "起购金额限制",
                                  prop: "is_minimum_amount",
                                  rules: [
                                    {
                                      required: true,
                                      trigger: "change",
                                      message: "请选择",
                                    },
                                  ],
                                },
                              },
                              [
                                _c(
                                  "span",
                                  { attrs: { slot: "label" }, slot: "label" },
                                  [
                                    _c("span", [_vm._v("起购金额限制")]),
                                    _c(
                                      "el-tooltip",
                                      {
                                        attrs: {
                                          content:
                                            "说明:每笔订单的总金额必须大于等于【最小起购金额】",
                                          placement: "top",
                                        },
                                      },
                                      [
                                        _c("i", {
                                          staticClass:
                                            "el-icon-warning-outline",
                                        }),
                                      ]
                                    ),
                                  ],
                                  1
                                ),
                                _c(
                                  "el-radio-group",
                                  {
                                    model: {
                                      value: _vm.setFormRule.is_minimum_amount,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.setFormRule,
                                          "is_minimum_amount",
                                          $$v
                                        )
                                      },
                                      expression:
                                        "setFormRule.is_minimum_amount",
                                    },
                                  },
                                  [
                                    _c("el-radio", { attrs: { label: "1" } }, [
                                      _vm._v("开启"),
                                    ]),
                                    _c("el-radio", { attrs: { label: "0" } }, [
                                      _vm._v("不开启"),
                                    ]),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                            _vm.setFormRule.is_minimum_amount === "1"
                              ? _c(
                                  "el-form-item",
                                  {
                                    attrs: {
                                      prop: "minimum_amount",
                                      label: "最小起购金额",
                                      rules: [
                                        {
                                          required: true,
                                          trigger: "change",
                                          message: "请输入",
                                        },
                                        {
                                          pattern:
                                            /^([0-9]{1,6})(\.[0-9]{1,2})?$/,
                                          message: "数字0～999999、小数点2位",
                                        },
                                      ],
                                    },
                                  },
                                  [
                                    _c(
                                      "el-input",
                                      {
                                        staticStyle: { width: "150px" },
                                        model: {
                                          value: _vm.setFormRule.minimum_amount,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              _vm.setFormRule,
                                              "minimum_amount",
                                              typeof $$v === "string"
                                                ? $$v.trim()
                                                : $$v
                                            )
                                          },
                                          expression:
                                            "setFormRule.minimum_amount",
                                        },
                                      },
                                      [
                                        _c("template", { slot: "append" }, [
                                          _vm._v("元"),
                                        ]),
                                      ],
                                      2
                                    ),
                                  ],
                                  1
                                )
                              : _vm._e(),
                          ],
                          1
                        )
                      : _vm._e(),
                  ]
                ),
                _c("div", { staticClass: "spaceBox" }),
                _c("div", { staticClass: "setBox" }, [
                  _c("div", { staticClass: "setTitle" }, [
                    _vm._v("子菜单设置-添加黑名单"),
                  ]),
                  _c(
                    "div",
                    { staticClass: "treeBox" },
                    [
                      _c("tree-transfer", {
                        ref: "treeTransfer",
                        attrs: {
                          title: ["支持的菜单（二三级菜单）", "不支持的菜单"],
                          from_data: _vm.menuList,
                          to_data: _vm.disabledMenuList,
                          "default-props": {
                            label: "name",
                            children: "_child",
                          },
                          mode: "transfer",
                        },
                      }),
                    ],
                    1
                  ),
                ]),
              ],
              1
            ),
            _c(
              "div",
              { staticClass: "dialog-footer" },
              [
                _c("el-button", { on: { click: _vm.handleClose } }, [
                  _vm._v("取 消"),
                ]),
                _c(
                  "el-button",
                  { attrs: { type: "primary" }, on: { click: _vm.save } },
                  [_vm._v("保 存")]
                ),
              ],
              1
            ),
          ]),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }